import { Resource, AllergyIntolerance } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils'

type Props = {
  resource?: Resource
}

const availFields = [
  { code: 'code', title: 'Substance' },
  { code: 'reaction', title: 'Reaction' },
  { code: 'clinical-status', title: 'Status' },
  { code: 'date', title: 'Documented' },
  { code: 'started', title: 'Started' },
  { code: 'completed', title: 'Completed' },
  { code: 'nonDrug', title: 'Non Drug' },
]

const renderColumn = (resource: AllergyIntolerance, itemCode: string): string => {
  switch (itemCode) {
    case 'code':
      return resource.code?.text || resource.code?.coding?.[0]?.display || 'NO KNOWN DRUG ALLERGIES'
    case 'reaction': {
      if (!resource.reaction?.length) return ''
      return resource.reaction
        .map((r) =>
          r.manifestation
            ?.map((m) => m.text || m.coding?.[0]?.display || '')
            .filter(Boolean)
            .join(', '),
        )
        .filter(Boolean)
        .join('; ')
    }
    case 'clinical-status':
      return (
        resource.clinicalStatus?.text ||
        resource.verificationStatus?.text ||
        resource.clinicalStatus?.coding?.[0]?.display ||
        '' ||
        resource.verificationStatus?.coding?.[0]?.display ||
        '' ||
        '-'
      )
    case 'date':
      return resource.recordedDate ? formatDateTime(resource.recordedDate) : ''
    case 'started': {
      const result =
        resource.onsetDateTime ||
        resource.onsetPeriod?.start ||
        resource.onsetRange?.low?.value?.toString() ||
        resource.onsetString ||
        ''

      return result ? formatDateTime(result) : result
    }
    case 'completed':
      return resource.lastOccurrence || ''
    case 'nonDrug':
      return resource.category?.includes('medication') ? '' : 'Yes'
    default:
      return ''
  }
}

export function Allergies({ resource }: Props) {
  const allergy = resource as AllergyIntolerance

  if (!allergy) {
    return null
  }

  return (
    <div className="border-b-1 border-b-gray-200 pb-2">
      <table className="text-base">
        <tbody>
          {availFields.map((item) => (
            <tr>
              <td className="py-1 text-sm font-bold text-[#7D7987]">{item.title}:</td>
              <td className="px-[8px] py-1 text-base text-sm">
                <div>{renderColumn(allergy, item.code)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
